<template>
    <div class="row gutter-sm q-mb-lg">
        <div :class="$q.platform.is.ipad ? 'col-12' : 'col-xs-12 col-sm-4'">
            <points :score="score" :score_statement="user_score_statement" @showStatement="showStatement" />
        </div>

        <div :class="$q.platform.is.ipad ? 'col-6' : 'col-xs-12 col-sm-4'">
            <statistics :statistics="statistics" :clientModules="clientModules" />
        </div>

        <div :class="$q.platform.is.ipad ? 'col-6' : 'col-xs-12 col-sm-4'" v-if="showRanking">
            <ranking @seeAll="seeAll()" />
        </div>

        <div class="col-12">
            <badges :badges="badges" />
        </div>

        <q-modal v-model="show_all_ranking" :content-css="{minWidth: '100vw', minHeight: '100vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_all_ranking = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('ranking') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <all-ranking :user_firebase_document_ranking_areas="user_firebase_document_ranking_areas" :user_firebase_document="user_firebase_document" />
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_statement" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_statement = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('points_statement') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <points-statemenet :score_statement="user_score_statement" />
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Points from 'components/profile/Points.vue'
import PointsStatement from 'components/profile/PointsStatement.vue'
import Ranking from 'components/profile/Ranking.vue'
import AllRanking from 'components/profile/AllRanking.vue'
import Badges from 'components/profile/Badges.vue'
import Statistics from 'components/profile/Statistics.vue'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "feed"] },

    components: {
        'points': Points,
        'points-statemenet': PointsStatement,
        'ranking': Ranking,
        'all-ranking': AllRanking,
        'badges': Badges,
        'statistics': Statistics
    },

    data() {
        return {
            score: null,
            user_score_statement: [],
            badges: null,
            show_all_ranking: false,
            statistics: [],
            show_statement: false,
            clientModules: {
                has_courses: false,
                has_trails: false,
                has_presential: false,
                has_live_classes: false,
                has_podcasts: false,
                has_webcasts: false
            }
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_firebase_document_ranking_areas: 'common/user_firebase_document_ranking_areas',
            user_firebase_document: 'common/user_firebase_document',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showRanking() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) {
                if (obj.has_ranking) return obj.has_ranking
            }
            else return false
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_profile/my_profile/get_user_statistics/`, this.getHeader)
            .then(response => {
                this.score = response.data.user_score.toFixed(2) * 1
                this.user_score_statement = response.data.user_score_statement
                this.badges = response.data.user_badges
                this.statistics = response.data

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        seeAll() {
            this.show_all_ranking = true
        },

        showStatement() {
            this.show_statement = true
        },

        checkClientModules() {
            const client = this.clients.find(obj => obj.id === this.id_user_client_selected)
            if (client) {
                for (const [key, value] of Object.entries(this.clientModules)) {
                    if (client[key] !== undefined) {
                        this.clientModules[key] = client[key]
                    }
                }
            } else return
        }
    },

    created() {
        this.checkClientModules()
        this.fetchAll()
    }
}
</script>

<style>

</style>
